import { SendTimecardLinkRequest } from '../timecard/timecardType';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class TimecardApi {



    static async getTimeCardShortReport(employee_code: string, current_day: boolean, current_week: boolean, current_month: boolean) {
        try {

            const response = await fetch(`${API_BASE_URL}/timecards/timecard_short_report?employee_code=${employee_code}&current_day=${current_day}&current_week=${current_week}&current_month=${current_month}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                //credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200 || response.status === 404) {
                //console.log('========responseBody =========:', responseBody);
                return responseBody;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get timecard report: ${error.message}`);
            } else {
                throw new Error('Failed to get timecard report: An unknown error occurred.');
            }
        }
    }


    static async sendTimecardLink(sendTimecardLinkRequestBody: SendTimecardLinkRequest) {
        try {
            const response = await fetch(`${API_BASE_URL}/timecards/send_link`, {
                method: 'POST',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(sendTimecardLinkRequestBody),
            });
            const responseBody = await response.json();
            if (response.status === 200) {
                return {
                    status: response.status,
                    responseBody: responseBody
                }
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to send timecard link: ${error.message}`);
            } else {
                throw new Error('Failed to send timecard link: An unknown error occurred.');
            }
        }
    }

    //========Create Timecard =================
    static async createTimecard(company_code: string, employee_code: string, jobsiteId: string) {
        try {

            //console.log('=====create timecards======', company_code, employee_code);

            const response = await fetch(`${API_BASE_URL}/timecards`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    timecard: {
                        company_code: company_code,
                        employee_code: employee_code,
                        jobsite_id: jobsiteId,  // Correct object structure
                    }
                }),

                //credentials: 'include', // Include cookies in the request
            });


            //const headers: { [key: string]: string } = {};
            //response.headers.forEach((value, key) => { headers[key] = value; });
            const responseBody = await response.json();
            return {
                status: response.status,
                responseBody: responseBody
            };
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create timecard: ${error.message}`);
            } else {
                throw new Error('Failed to create timecard: An unknown error occurred.');
            }
        }
    }

    static async getEmployeeTimecards(employee_code: string, jobsite_id: string, timecard_date: string) {
        try {

            const response = await fetch(`${API_BASE_URL}/employees/${employee_code}/timecards?jobsite_id=${jobsite_id}&timecard_date=${timecard_date}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                //credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200 || response.status === 404) {
                //console.log('========responseBody =========:', responseBody);
                /*                                 */
                return {
                    status: response.status,
                    responseBody: responseBody
                };
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get timecard: ${error.message}`);
            } else {
                throw new Error('Failed to get timecard: An unknown error occurred.');
            }
        }
    }

    //=======Update timecard==============
    static async updateTimecard(timecardId: string, clockOut: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/timecards/${timecardId}`, {
                method: 'PATCH',
                //credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    timecard: {
                        clock_out: clockOut,  // Correct object structure
                    }
                }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //return company;
            }
            else {

                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update timecard: ${error.message}`);
            } else {
                throw new Error('Failed to update timecard: An unknown error occurred.');
            }
        }
    }

    static async delete(company_code: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/timecards/${company_code}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return {
                status: response.status,
                ok: response.ok,
            };
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete timecard: ${error.message}`);
            } else {
                throw new Error('Failed to get delete timecard: An unknown error occurred.');
            }
        }
    }

    static async getTimecardReport(startDate: string, endDate: string, employeeCode: string, jobsiteId: string, hourlyRate: string) {

        const queryParams = {
            start: startDate,
            end: endDate,
            employee_code: employeeCode,
            jobsite_id: jobsiteId,
            hourly_rate: hourlyRate,
        };

        // Filter out any undefined or empty values
        const queryString = Object.entries(queryParams)
            .filter(([_, value]) => value !== undefined && value !== "")
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join("&");

        const url = `${API_BASE_URL}/timecards/timecard_report?${queryString}`;
        //console.log('=====url======', url)
        try {

            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                //credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //console.log('========responseBody =========:', responseBody);
                /*      
                return {
                    status: response.status,
                    responseBody: responseBody
                };
                */
                return responseBody;
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get timecard report: ${error.message}`);
            } else {
                throw new Error('Failed to get timecard report: An unknown error occurred.');
            }
        }
    }

}

export default TimecardApi;